up.compiler('[new-record]', (element) => {
  let form = up.element.closest(element, 'form')
  up.validate(form, { target: 'form [reload-on-adding-new-record] ' })
})
